import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button';
import { IconComponent } from '../icon';
@Component({
  selector: 'sc-restart-declaration-sheet',
  styleUrls: ['./restart-declaration-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, ButtonComponent, TranslateModule],
  template: `
    <div class="restart-declaration-container">
      <button type="button" class="close-btn" (click)="onCancelClick()">
        <sc-icon name="close"></sc-icon>
        <span class="sr_only">{{
          'GlobalApplicativeConstants.accessibility.closeDialog'
            | translate
              : {
                  dialogTitle: 'RestartDeclarationDialog.title' | translate
                }
        }}</span>
      </button>

      <div class="warn-icon">
        <sc-icon name="alert"></sc-icon>
      </div>

      <h1
        mat-dialog-title
        id="restart-declaration-title-id"
        class="sc-design-title-h2"
      >
        {{ 'RestartDeclarationDialog.title' | translate }}
      </h1>

      <ng-container>
        <p class=" sc-design-text-4">
          {{ 'RestartDeclarationDialog.infoText' | translate }}
        </p>
      </ng-container>

      <ng-container>
        <sc-button (click)="onConfirmClick()">{{
          'RestartDeclarationDialog.confirmBtn' | translate
        }}</sc-button>

        <sc-button buttonType="tertiary" (click)="onCancelClick()">{{
          'RestartDeclarationDialog.cancelmBtn' | translate
        }}</sc-button>
      </ng-container>
    </div>
  `,
})
export class RestartDeclarationSheetComponent {
  @Output() cancelEvent = new EventEmitter<string>();
  @Output() confirmEvent = new EventEmitter<string>();

  onCancelClick() {
    this.cancelEvent.emit('cancel');
  }

  onConfirmClick() {
    this.confirmEvent.emit('success');
  }
}
